module.exports = __webpack_public_path__ + "static/media/SWSCRC1-36.ceb7891b.mp3";